import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";

import './App.css';
import Login from './components/page/Login/Login';
import ResetPassword from './components/page/Login/ResetPassword';
import Stock from './components/page/Stock/Stock';
import Shop from './components/page/Shop/Shop';
import ShopEdit from './components/page/Shop/ShopEdit';
import Settle from './components/page/Settle/Settle';
import SettlePayment from './components/page/SettlePayment/SettlePayment';
import Ship from './components/page/Ship/Ship';
import Hold from './components/page/Ship/Hold';
import Ordered from './components/page/Ship/Ordered';
import Shipped from './components/page/Ship/Shipped';
import Direction from './components/page/Ship/Direction';
import Sales from './components/page/Sales/Sales';
import SalesMonthly from './components/page/SalesMonthly/SalesMonthly';
import NewOripa from './components/page/Oripa/NewOripa';
import Preview from './components/page/Oripa/Preview/Preview';
import Oripa from './components/page/Oripa/Oripa';
import User from './components/page/User/User';
import Ranking from './components/page/Ranking/Ranking';
import RankingDaily from './components/page/RankingDaily/RankingDaily';
import RankingWeekly from './components/page/RankingWeekly/RankingWeekly';
import ShopPayment from './components/page/Payment/ShopPayment';
import ShopPaymentCoupon from './components/page/PaymentCoupon/ShopPaymentCoupon';
import Rate from './components/page/Rate/Rate';
import Single from './components/page/Single/Single';
import Lot from './components/page/Lot/Lot';
import LotDetail from './components/page/Lot/LotDetail';
import WmsSettings from './components/page/Wms/WmsSettings';
import PointGrantRule from './components/page/PointGrantRule/PointGrantRule';
import Staff from './components/page/Staff/Staff';
import OperatorAnnouncement from './components/page/OperatorAnnouncement/OperatorAnnouncement';
import DrawTransactions from './components/page/DrawTransactions/DrawTransactions';
import ShipPayments from './components/page/ShipPayments/ShipPayments';
import RefundQueue from './components/page/RefundQueue/RefundQueue';

import Main from './components/page/Main/Main';
import ShipDetail from './components/page/Ship/ShipDetail';
import ResetPasswordSubmit from './components/page/Login/ResetPasswordSubmit';

import { getUserRole, setRoleCookies, clearRoleCookies, hasPermission, getDefaultPage } from './utils/auth';

function App() {
  const [isLogined, setIsLogined] = useState(false);
  const [sessionToken, setSessionToken] = useState('');
  const [shopPath, setShopPath] = useState('');
  const [userRole, setUserRole] = useState(getUserRole());

  const [isRequireUpdate, setIsRequireUpdate] = useState(false);


  useEffect(() => {
    if (document.cookie) {

      const shop = window.location.pathname.split('/')[1];

      const cookies = document.cookie.replace(/ /g,"").split(';');
      cookies.forEach(cookie => {
        const cookieArray = cookie.split('=');
        if (cookieArray[0] === 'token') {
          let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
          if(xsrfToken) xsrfToken = xsrfToken.split('=')[1];
          fetch(`${process.env.REACT_APP_API_URL}/api/is_enabled_shop_user?shop_path=${shop}`, {
            headers: {
              'Content-Type': 'application/json',
              'X-XSRF-TOKEN': xsrfToken,
              'Bearer': cookieArray[1],
              'Accept': 'application/json'
            },
            credentials: 'include',
            method: 'GET'
          }).then(res => {
            if (res.status === 200) {
              setIsLogined(true);
              setSessionToken(cookieArray[1]);

              let data = res.json();
              data.then(data => {
                if (data.require_update) {
                  setIsRequireUpdate(true);
                }
              });

              // Fetch /api/me to sync role
              fetch(`${process.env.REACT_APP_API_URL}/api/me`, {
                headers: {
                  'Content-Type': 'application/json',
                  'X-XSRF-TOKEN': xsrfToken,
                  'Bearer': cookieArray[1],
                  'Accept': 'application/json'
                },
                credentials: 'include',
                method: 'GET'
              }).then(meRes => {
                if (meRes.status === 200) {
                  meRes.json().then(meData => {
                    if (meData.role) {
                      setRoleCookies(meData.role, meData.user_type);
                      setUserRole(meData.role);
                    }
                  });
                }
              }).catch(() => {
                // /api/me failure is non-critical - use cookie role
              });

            } else {
              setIsLogined(false);
              setSessionToken(cookieArray[1]);
            }
          }).catch(err => {
            setIsLogined(false);
            setSessionToken(cookieArray[1]);
          });
        }
      });
    }
  }, []);

  const hp = (page) => hasPermission(userRole, page);
  const defaultPage = getDefaultPage(userRole);

  return (
    <BrowserRouter>
      {isLogined &&
        <>
            {!isRequireUpdate ?
              <>
                <Routes>
                  <Route path="/:shop/" element={<Main setShopPath={setShopPath} />}>
                    <Route path={``} element={<DefaultRedirect defaultPage={defaultPage} />} />
                    {hp('stock') && <Route path={`stock`} element={<Stock />} />}
                    {hp('oripa') && <Route path={`oripa/:id`} element={<Oripa />} />}
                    {hp('oripa') && <Route path={`oripa/:id/force`} element={<Oripa force={true} />} />}
                    {hp('oripa') && <Route path={`oripa/:id/edit`} element={<NewOripa />} />}
                    {hp('oripa') && <Route path={`oripa/:id/preview`} element={<Preview />} />}
                    {hp('new-oripa') && <Route path={`new-oripa`} element={<NewOripa />} />}
                    {hp('ranking') && <Route path={`ranking`} element={<Ranking />} />}
                    {hp('ranking') && <Route path={`ranking-daily`} element={<RankingDaily />} />}
                    {hp('ranking') && <Route path={`ranking-weekly`} element={<RankingWeekly />} />}
                    {hp('sales') && <Route path={`sales`} element={<Sales />} />}
                    {hp('sales') && <Route path={`sales-monthly`} element={<SalesMonthly />} />}
                    {hp('settle') && <Route path={`settle`} element={<Settle />} />}
                    {hp('settle-payment') && <Route path={`settle-payment`} element={<SettlePayment />} />}
                    {hp('single') && <Route path={`single`} element={<Single />} />}
                    {hp('ship') && <Route path={`ship`} element={<Ship />} />}
                    {hp('ship') && <Route path={`ship/lots`} element={<Lot />} />}
                    {hp('ship') && <Route path={`ship/lots/:lotId`} element={<LotDetail />} />}
                    {hp('ship') && <Route path={`ship/:id`} element={<ShipDetail />} />}
                    {hp('ship') && <Route path={`ship/hold`} element={<Hold />} />}
                    {hp('ship') && <Route path={`ship/ordered`} element={<Ordered />} />}
                    {hp('ship') && <Route path={`ship/shipped`} element={<Shipped />} />}
                    {hp('ship') && <Route path={`ship/direction`} element={<Direction />} />}
                    {hp('shop') && <Route path={`shop`} element={<Shop />} />}
                    {hp('shop-edit') && <Route path={`shop-edit`} element={<ShopEdit />} />}
                    {hp('wms-settings') && <Route path={`wms-settings`} element={<WmsSettings />} />}
                    {hp('point-grant-rules') && <Route path={`point-grant-rules`} element={<PointGrantRule />} />}
                    {hp('shop-payment') && <Route path={`shop-payment`} element={<ShopPayment />} />}
                    {hp('shop-payment-coupon') && <Route path={`shop-payment-coupon`} element={<ShopPaymentCoupon />} />}
                    {hp('user') && <Route path={`user`} element={<User />} />}
                    {hp('rate') && <Route path={`rate`} element={<Rate />} />}
                    {hp('staff') && <Route path={`staff`} element={<Staff />} />}
                    {hp('operator-announcement') && <Route path={`operator-announcement`} element={<OperatorAnnouncement />} />}
                    {hp('draw-transactions') && <Route path={`draw-transactions`} element={<DrawTransactions />} />}
                    {hp('ship-payments') && <Route path={`ship-payments`} element={<ShipPayments />} />}
                    {hp('refund-queue') && <Route path={`refund-queue`} element={<RefundQueue />} />}
                    <Route path={`logout`} element={<Logout setIsLogined={setIsLogined} setSessionToken={setSessionToken}/>} />
                    <Route path="*" element={<DefaultRedirect defaultPage={defaultPage} />} />
                  </Route>
                  <Route path="*" element={<NoMatch />} />
                </Routes>
              </>
              :
              <>
                 <Routes>
                  <Route path="/:shop/" element={<Main setShopPath={setShopPath} />}>
                    <Route path={``} element={<ShopEdit  onlyShop={true} />} />
                    <Route path={`shop`} element={<Shop  onlyShop={true} />} />
                    <Route path={`shop-edit`} element={<ShopEdit  onlyShop={true} />} />
                    <Route path={`logout`} element={<Logout setIsLogined={setIsLogined} setSessionToken={setSessionToken}/>} />
                  </Route>
                  <Route path="*" element={<NoMatch />} />
                </Routes>
              </>
            }
        </>
      }
      {!isLogined &&
        <>
            <Routes>
              <Route path="/:shop/" element={<Main setShopPath={setShopPath} />}>
                  <Route path={``} element={<Login  setIsLogined={setIsLogined} setSessionToken={setSessionToken}/>} />
                  <Route path={`reset-password`} element={<ResetPassword />} />
                  <Route path={`password-reset`} element={<ResetPasswordSubmit />} />
                  <Route path={`*`} element={<Login  setIsLogined={setIsLogined} setSessionToken={setSessionToken}/>} />
              </Route>
              <Route path="*" element={<NoMatch />} />
            </Routes>
        </>
      }
    </BrowserRouter>
  );
}

function DefaultRedirect({ defaultPage }) {
  const { shop } = useParams();
  return <Navigate to={`/${shop}/${defaultPage}`} replace />;
}

function NoMatch() {
  return (
    <div>
      404 Not Found
    </div>
  );
}

function Logout({setIsLogined, setSessionToken}) {
  const { shop } = useParams();

  useEffect(() => {
    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    fetch(`${process.env.REACT_APP_API_URL}/api/logout`, {
      headers: {
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': xsrfToken,
        'Bearer': document.cookie.split('; ').find(row => row.startsWith('token')).split('=')[1],
        'Accept': 'application/json'
      },
      credentials: 'include',
      method: 'POST'
    }).then(res => {
      setIsLogined(false);
      setSessionToken('');
      document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 GMT;max-age=0;path=/';
      clearRoleCookies();
      window.location.href = `/${shop}/`;
    }).catch(err => {
      setIsLogined(false);
      setSessionToken('');
      document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 GMT;max-age=0;path=/';
      clearRoleCookies();
      window.location.href = `/${shop}/`;
    });
  }, []);

  return null;
}

export default App;
